import robot from '../resources/media/Bot-1x-size.png';
import externalLinkIcon from '../resources/media/external_link.svg';
import React, {useEffect, useState} from 'react';
import * as _ from 'lodash';
import {
    base64ToJson,
    getCookie,
    getJsonQueryString,
    removeCookie,
    verifyNetAppDomain
} from '../common/utils';
import {CIG_SSO, DOC_CENTER_TROUBLESHOOT_PATH, DOC_CENTER_URL} from '../common/constants';
import CigHeader from '../components/CigHeader';


export const BulletPointMessage = () => {
    return (
        <React.Fragment>
            <li>Session time out leading to log out.</li>
            <li>Upstream authorization revoked.</li>
            <li>You logged out from Data Infrastructure Insights.</li>
        </React.Fragment>
    )
};
BulletPointMessage.displayName = 'BulletPointMessage';


export function CigLogoutPage(){
    const [logoutMessage, setLogoutMessage] = useState({});

    const verifyPathName = (pathName) => {
        return _.isEmpty(pathName) || /^[/#?]/.test(pathName) === true;
    }

    useEffect(() => {
        const queryStr = getJsonQueryString();
        let ckName = _.get(queryStr, CIG_SSO.logout, '');
        let ckValue = getCookie('', ckName);
        let site = '';
        let pathName = '';
        let siteName = '';
        if (!_.isEmpty(ckName) && !_.isEmpty(ckValue)) {
            try {
                const value = base64ToJson(ckValue);
                site = _.get(value, 'site', window.location.hostname);
                if (!verifyNetAppDomain(site)) {
                    site = '';
                }
                pathName =  _.get(value, 'redirect', '');
                if (!verifyPathName(pathName)) {
                    pathName = '';
                }
            }
            catch (e) {
                window.CIG_LOG.debug('Failed to get logout tenant');
                site = '';
            }
            removeCookie(ckName);
        }

        removeCookie(CIG_SSO.cookieJWT);
        removeCookie(CIG_SSO.contextCookie);

        if (_.isNil(window.history.state) || _.isNil(window.history.state[CIG_SSO.historyUrl]) ||
            (!_.isEmpty(site) && site !== window.history.state[CIG_SSO.historyUrl])) {
            if (_.isEmpty(site)) {
                site = window.location.hostname;
            }
            window.history.replaceState({cigurl: site, path: pathName}, null, window.location.href);
        }
        else {
            const host = _.get(window.history.state, CIG_SSO.historyUrl, '');
            if (_.isEmpty(host)) {
                site = window.location.hostname;
            }
            else {
                site = host;
            }
        }

        if (!_.isEmpty(site)) {
            siteName = _.startsWith(site,'gateway') || _.startsWith(site,'localhost') ? '' : site;
        }
        const message = {
            text:  'You have been logged out of Data Infrastructure Insights' + (_.isEmpty(siteName) ? '.' : ':'),
            siteName: siteName
        };
        setLogoutMessage(message);
    }, []);

    const signIn = (e) => {
        e.preventDefault();
        if (!_.isNil(window.history.state) && !_.isNil(window.history.state[CIG_SSO.historyUrl])) {
            const tenantHost = window.history.state[CIG_SSO.historyUrl];
            if (!_.isEmpty(tenantHost) && verifyNetAppDomain(_.trim(tenantHost))) {
                const pathName = _.get(window.history.state, 'path', '');
                let host = 'https://' + tenantHost;
                if (verifyPathName(pathName)) {
                    host += _.trim(pathName);
                }
                // Replace logout URL so that user can not go back to logout page after start login
                window.history.replaceState({}, null, window.location.origin);
                window.CIG_LOG.debug('Gateway: Expected host: ' + _.get(logoutMessage, 'siteName', ''));
                window.CIG_LOG.debug('Gateway: Found host: ' + _.get(logoutMessage, 'siteName', '') + ' Navigated to ' + host);
                window.open(host, '_self');
            }
            else if (!_.isEmpty(_.get(logoutMessage, 'siteName', '')) && verifyNetAppDomain(logoutMessage.siteName)) {
                let host = 'https://' + logoutMessage.siteName;
                window.history.replaceState({}, null, window.location.origin);
                window.CIG_LOG.debug('Gateway: No history found. Navigated to ' + host);
                window.open(host, '_self');
            }
        }
        else {
            window.CIG_LOG.info('Gateway: Navigated to ' + window.location.origin);
            window.open(window.location.origin, '_self');
        }
    }

    return (
        <div id="logout-container" className="tw-m-auto" data-testid="logout-container">
            <CigHeader showLogout={false} />
            <div id="logout-body" className="tw-flex tw-w-full tw-bg-blue-100" style={{height: '93vh'}} data-testid="logout-body">
                <div style={{width: '45%', padding: '0 30px'}} data-testid="logout-robot-container">
                    <div id="logout-robot" className="tw-flex tw-justify-center tw-mt-48px tw-ml-80px">
                        <div>
                            <div id="logout-text" className="tw-font-hairline tw-text-2xl">Logged Out</div>
                            <div id="robot" style={{paddingTop: '100px'}}>
                                <img src={robot}  alt="robot" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tw-mt-48px" style={{width: '45%', paddingTop: '150px', paddingRight: '30px'}}>
                    <div id="logout-msg-box" className="tw-bg-white tw-w-auto" >
                        <div className="tw-mx-28px tw-py-xl">
                            <p id="logout-msg" className="tw-text-med tw-font-bold" data-testid="logout-msg">
                                {logoutMessage.text}
                            </p>
                            <p id="logout-hostname" className="tw-text-med tw-font-bold tw-pb-16px" data-testid="logout-hostname">
                                {logoutMessage.siteName}
                            </p>
                            {
                                !_.isEmpty(logoutMessage.siteName) && <button id="logout-signin-button"
                                    className="tw-border tw-border-netapp-blue tw-py-6px tw-px-20px tw-rounded-md tw-text-white tw-bg-netapp-blue hover:tw-bg-blue-500 "
                                    onClick={signIn}>
                                    Login
                                </button>
                            }
                            <p className="tw-pt-20px tw-pb-lg" data-testid="auto-logout-text">
                                Automatic logout can occur for the following reasons:
                            </p>
                            <ul id="logout-trouble-box" className="tw-list-disc tw-ml-24px tw-pb-20px tw-leading-10">
                                <BulletPointMessage />
                            </ul>
                            <div id="logout-doc-link" className="tw-inline-block tw-m-0">
                                <span className="tw-inline">Try logging in again, or&nbsp;</span>
                                <a className="tw-text-link tw-inline" href={DOC_CENTER_URL + DOC_CENTER_TROUBLESHOOT_PATH} target="_blank" rel="noopener noreferrer">
                                    learn how to resolve this issue&nbsp;
                                    <img className="tw-inline tw-items-center tw-pb-5px" src={externalLinkIcon} width="16px" alt=">" />
                                </a>
                            </div>
                            <p className="tw-leading-10" data-testid="close-tab-msg">
                                Close the browser tab if you do not intend to log in again at the moment.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

CigLogoutPage.displayName = 'CigLogoutPage';
export default CigLogoutPage;
